import { Injectable } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root'
})
export class ExcessProtectService {
  constructor(private sharedService: SharedService, private sessionSt: LocalStorageService) {
  }

  convertToPolicy(data) {
    return this.sharedService.postAPI('excessprotect/quote/convert_to_policy', data);
  }

  // Get All Static Data
  getStaticData(authDetails) {
    return this.sharedService.getAmlineAPI('horsebox-api/lists', authDetails);
  }

  // Get Excess Protect Data
  getExcessProtectData(id: string) {
    return this.sharedService.getAPI('excessprotect/quote/' + id);
  }

  getHorseboxOptions(version: string = '1') {
    return this.sharedService.getAPI('horsebox/options/' + version);
  }

  // Save Indicative Quote
  saveQuote(data) {
    return this.sharedService.postAPI('excessprotect/quote', data);
  }

  // Calculate Premium
  calculatePremium(data) {
    return this.sharedService.postAPI('excessprotect/quote/calculate', data);
  }

  // Get Quote Details
  getQuoteDetails(id) {
    return this.sharedService.getAPI('excessprotect/quote/' + id);
  }

  // Get Quote Details
  getQuoteDetailsByQuoteID(id) {
    return this.sharedService.getAPI('excessprotect/quote/' + id);
  }

  // GET UNIQUE ID FOR DRIVERS
  getUniqueID() {
    return this.sharedService.getAPI('excessprotect/generate-id');
  }

  /*
  * Create Quote Object for Save API
  */
  createQuoteObj(data) {
    return {
      data: {
        type: 'excessprotect/quote',
        attributes: {
          declaration: true,
          proposer: data.proposer,
        },
      }
    };
  }

  /*
  * Issue The Quote
  */
  issueQuote(data) {
    return this.sharedService.postAPI('excessprotect/quote/convert_to_policy', data);
  }

  /*
  * Get Cancellation Return Premium
  */
  getReturnPremium(data, policyId, authDetails) {
    return this.sharedService.postAPI('excessprotect/policy/' + policyId + ':return-premium', data);
  }

  /*
  * Cancel Policy
  */
  getCancelPolicy(data, policyId) {
    return this.sharedService.postAPI('excessprotect/policy/' + policyId + ':cancel', data);
  }

  /*
  * Cancel Policy
  */
  getVehicleDetails(registrationNumber) {
    return this.sharedService.getAPI('excessprotect/vehicle/' + registrationNumber);
  }

  getAgreedQuestions(productId, agreedQuestionVersion = 1) {
    return this.sharedService.getAPI('staticdata/agreed_questions/' + productId + '/' + agreedQuestionVersion);
  }

  getAccessToken(data) {
    return this.sharedService.postAmlineAPI('oauth/token', data);
  }

  getExcessProtectOptions(version: string = '1') {
    return this.sharedService.getAPI('excessprotect/options/' + version);
  }
  calculateMTAFinancials(data) {
    return this.sharedService.postAPI('excess-protect/calculate-mta', data);
  }
}
